import { render, staticRenderFns } from "./MsRadio.vue?vue&type=template&id=5d301159&scoped=true"
import script from "./MsRadio.vue?vue&type=script&lang=js"
export * from "./MsRadio.vue?vue&type=script&lang=js"
import style0 from "./MsRadio.vue?vue&type=style&index=0&id=5d301159&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d301159",
  null
  
)

export default component.exports